import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import BrakeF from "../../assets/BrakeF.jpg";

const BrakeFlush = () => {
  return (
    <>
      <SeoHead
        title="Brake Fluid Flush in Temecula | Advanced Automotive Smog"
        description="Brake fluid flush in Temecula to remove moisture-contaminated fluid and help keep pedal feel firm and stopping power consistent."
        path="/services/brake-flush"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Brake Flush"
          path="/services/brake-flush"
          description="Brake fluid flush in Temecula to remove moisture-contaminated fluid and help keep pedal feel firm and stopping power consistent."
          serviceType="Brake fluid flush"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={BrakeF}
                alt="Brake fluid service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Brake System Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Brake Flush
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Your brakes are only as strong as the fluid behind them. A proper
              brake flush helps keep your pedal feel firm and your stopping
              power consistent—especially in emergency situations.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What is a Brake Flush?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Brake fluid absorbs moisture over time, which can lead to rust,
              internal corrosion, and a soft or spongy pedal. A brake flush
              removes the old, contaminated fluid and replaces it with fresh,
              clean fluid throughout the entire system.
              <br />
              <br />
              Our technicians use the proper equipment and procedures to bleed
              and refill your system, helping your brakes stay responsive and
              reliable.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improves brake performance and pedal feel</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps prevent moisture buildup and internal corrosion</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Extends the life of brake components</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Service available for all makes and models</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional bleeding and post-service testing</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default BrakeFlush;

